import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';

const CheckboxGenerico = ({ initialState, id, onChange, style }) => {
  const [checked, setChecked] = useState(initialState);
  
  const onClick=(checked)=>{
   setChecked(checked);
   onChange(id, checked);
  }
  return (
    <Checkbox 
        checked={checked}  
        onClick={e => onClick(e.target.checked)}
        style={style}
    />
  );
}

export default CheckboxGenerico


